import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { HardDrive, AppWindow } from "lucide-react";
import { VulnerabilityDashboard } from "@/components/patching/vulnerabilities/VulnerabilityDashboard";
import { AppVulnerabilityDashboard } from "@/components/vulnerabilities/app/AppVulnerabilityDashboard";

export default function VulnerabilitiesPage() {
  return (
    <div className="px-6 py-6 min-h-screen bg-background">
      <div className="mb-8">
        <h1 className="text-2xl font-bold tracking-tight">Vulnerabilities</h1>
        <p className="text-muted-foreground mt-1">
          Monitor and manage security vulnerabilities across OS updates and applications
        </p>
      </div>

      <Tabs defaultValue="os" className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="os" className="flex items-center gap-2">
            <HardDrive className="h-4 w-4" />
            Operating System
          </TabsTrigger>
          <TabsTrigger value="apps" className="flex items-center gap-2">
            <AppWindow className="h-4 w-4" />
            Applications
          </TabsTrigger>
        </TabsList>

        <TabsContent value="os" className="mt-6">
          <VulnerabilityDashboard />
        </TabsContent>

        <TabsContent value="apps" className="mt-6">
          <AppVulnerabilityDashboard />
        </TabsContent>
      </Tabs>
    </div>
  );
}
